import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './ui/CTAButton';
export function HeroSection() {
  return <section className="relative border-b-[3px] border-gold bg-gradient-to-br from-black to-surface-dark px-6 py-10 md:px-20 md:py-[60px] pb-[50px] overflow-hidden min-h-[85vh] flex flex-col justify-center" data-id="element-53">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-54">
        <div className="absolute inset-0 bg-gradient-to-b from-black/90 via-surface-dark/95 to-black z-10" data-id="element-55" />
        <img src="https://cdn.magicpatterns.com/uploads/bhbAZVydAEcDj1CTF6wiir/Imagen_Codigo_de_identidad-6.png" alt="Hombre analizando el código de identidad" className="w-full h-full object-cover object-top opacity-30 grayscale" data-id="element-56" />
      </div>

      <div className="relative z-20 max-w-[1100px] mx-auto w-full flex flex-col items-center text-center" data-id="element-57">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="flex flex-col items-center" data-id="element-58">
          <div className="mb-5 flex items-center gap-2.5" data-id="element-59">
            <div className="rounded-sm bg-gold px-3.5 py-1 font-heading text-[9px] font-black tracking-[3px] text-black uppercase" data-id="element-60">
              SISTEMA RMA
            </div>
            <div className="text-[11px] tracking-[2px] text-text-ultramuted uppercase font-bold" data-id="element-61">
              ⏱ 48 Horas · Nivel: Avanzado
            </div>
          </div>

          <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-gold uppercase" data-id="element-62">
            <span className="inline-block h-[2px] w-5 bg-gold" data-id="element-63"></span>
            LA CIRUGÍA AUDITIVA Y MENTAL PARA ANIQUILAR EL VIRUS INVISIBLE QUE
            BLOQUEA TU RIQUEZA
          </div>

          <h1 className="mb-6 font-heading text-5xl md:text-[64px] lg:text-[80px] font-black leading-[1.05] text-white uppercase tracking-tight" data-id="element-64">
            EL CÓDIGO DE <br className="hidden md:block" data-id="element-65" />
            <span className="text-gold" data-id="element-66">IDENTIDAD 1.0</span>
          </h1>

          <div className="mb-10 max-w-[750px] flex flex-col items-center gap-4" data-id="element-67">
            <div className="flex flex-col md:flex-row items-center gap-3 md:gap-5" data-id="element-68">
              <div className="flex items-center gap-2.5 rounded-lg border border-border bg-surface px-4 py-3" data-id="element-69">
                <span className="text-[20px]" data-id="element-70">🧠</span>
                <span className="text-[13px] md:text-[14px] font-bold text-white tracking-[0.5px]" data-id="element-71">
                  Extrae el paradigma subconsciente
                </span>
              </div>
              <span className="hidden md:block text-gold font-black text-[18px]" data-id="element-72">
                →
              </span>
              <div className="flex items-center gap-2.5 rounded-lg border border-border bg-surface px-4 py-3" data-id="element-73">
                <span className="text-[20px]" data-id="element-74">🌡️</span>
                <span className="text-[13px] md:text-[14px] font-bold text-white tracking-[0.5px]" data-id="element-75">
                  Resetea tu termostato financiero
                </span>
              </div>
              <span className="hidden md:block text-gold font-black text-[18px]" data-id="element-76">
                →
              </span>
              <div className="flex items-center gap-2.5 rounded-lg border border-gold/30 bg-gold/10 px-4 py-3" data-id="element-77">
                <span className="text-[20px]" data-id="element-78">💰</span>
                <span className="text-[13px] md:text-[14px] font-bold text-gold tracking-[0.5px]" data-id="element-79">
                  Deja de empujar la pared invisible
                </span>
              </div>
            </div>
            <div className="rounded-sm bg-gold px-4 py-1.5 font-heading text-[10px] font-black tracking-[3px] text-black uppercase" data-id="element-80">
              ⏱ En solo 48 horas
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.3,
        ease: 'easeOut'
      }} className="w-full flex flex-col items-center" data-id="element-81">
          <CTAButton data-id="element-82" />

          <div className="mt-8 flex flex-col md:flex-row gap-4 md:gap-6 justify-center" data-id="element-83">
            <div className="flex items-center gap-2 text-[12px] text-[#555] font-bold uppercase tracking-[1px]" data-id="element-84">
              <div className="h-1.5 w-1.5 rounded-full bg-gold" data-id="element-85"></div>
              Reprogramación Subconsciente
            </div>
            <div className="flex items-center gap-2 text-[12px] text-[#555] font-bold uppercase tracking-[1px]" data-id="element-86">
              <div className="h-1.5 w-1.5 rounded-full bg-gold" data-id="element-87"></div>
              Resultados en 7 días
            </div>
            <div className="flex items-center gap-2 text-[12px] text-[#555] font-bold uppercase tracking-[1px]" data-id="element-88">
              <div className="h-1.5 w-1.5 rounded-full bg-gold" data-id="element-89"></div>
              Acceso Inmediato
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}